import { Button } from "primereact/button";
import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
import { formFields as additionalPatientPayStepsForm } from "../AdditionalPatientPayStepsFormConfig";
import { useLegacyLookup } from "./useLegacyLookup";

/**
 *
 * @param {{apsAddtlPatPaySch: string, apsAddtlPatpaySchDesc: string}[]} selectedSchedules
 * @returns
 */
function getParamsData(selectedSchedules, initialIndex) {
  return {
    schedule: selectedSchedules[initialIndex]?.apsAddtlPatPaySch,
    description: selectedSchedules[initialIndex]?.apsAddtlPatpaySchDesc,
  };
}

const useAdditionalPatientPaySteps = (
  onSelect,
  hideModal,
  selectParams,
  selectMode,
  lookupType,
  selectModeSchedule,
  scheduleDesc,
  setFalg,
  onNavigate
) => {
  const { axios_helper_no_header } = useAxios();
  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const location = useLocation();
  const { viewLookupDetails } = useLegacyLookup();

  const stateVal = location.state || [];
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);

  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.ADDITIONAL_PATIENT_PAY,
    currentIndex: initialIndex = 0,
  } = currentState;
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const intialParamData = selectMode
    ? { schedule: selectModeSchedule.apsAddtlPatPaySch, description: "" }
    : {
        schedule: selectedSchedules[initialIndex].apsAddtlPatPaySch,
        description: selectedSchedules[initialIndex].apsAddtlPatpaySchDesc,
      };
  const [paramsData, setParamsData] = useState(intialParamData);

  const handleMacListLookupClick = useCallback(
    (rowData) => {
      const macListField = additionalPatientPayStepsForm.find(
        (field) => field.name === "macList"
      );
      if (!macListField?.externalProgram) {
        return;
      }
      viewLookupDetails(
        macListField.externalProgram,
        macListField.params,
        rowData
      );
    },
    [viewLookupDetails]
  );

  const findScheduleDescription = (responseData, scheduleKey) => {
    const result = responseData.find(
      (item) => item.apsAddtlPatPaySch === scheduleKey
    );
    return result ? result.apsAddtlPatpaySchDesc : null;
  };

  const fetchDescription = async (scheduleKey) => {
    try {
      const rawResponse = await axios_helper_no_header(
        "GET",
        `api/apsAdlPatPaySched/${encodeURIComponent(scheduleKey)}`,
        null,
        null
      );
      const response = rawResponse.responseData;
      // const description = findScheduleDescription(response, scheduleKey);
      const description = response.apsAddtlPatpaySchDesc;
      setParamsData((prevState) => ({
        ...prevState,
        description: description || "",
      }));
    } catch (error) {
      console.error("Error fetching description:", error);
      setParamsData((prevState) => ({
        ...prevState,
        description: "",
      }));
    }
  };

  useEffect(() => {
    if (selectMode && selectModeSchedule?.apsAddtlPatPaySch) {
      fetchDescription(selectModeSchedule.apsAddtlPatPaySch);
    }
  }, [selectMode, selectModeSchedule]);

  const {
    ADDITIONAL_PATIENT_PAY_STEPS_ADD,
    ADDITIONAL_PATIENT_PAY_STEPS_EDIT,
    ADDITIONAL_PATIENT_PAY_STEPS_DISPLAY,
    COPY_PRICE_SCHEDULE,
    PRICE_SCHEDULE_NOTE,
  } = ROUTE_PATHS;
  const screen_title = "Additional Patient Pay Schedule Step";
  const screenNumber = selectMode ? "RCAPT004" : "RCAPT002";

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = selectMode
    ? [
        {
          button_label: "Back",
          button_handeler: () => {
            hideModal();
          },
          button_key: "F12",
        },
      ]
    : [
        {
          button_label: "Back",
          button_handeler: () => {
            if (currentIndex < selectedSchedules.length - 1) {
              setCurrentIndex(currentIndex + 1);
            } else {
              navigateToPage(previousScreen, previousState);
            }
          },
          button_key: "F12",
        },
      ];

  /* Search form fields that needs to be shown for filtering */
  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "schedule",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "description",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 25,
    },
  ];

  /* ACTION BUTTONS info that needs to be displayed on the page */
  const ctaButtons = selectMode
    ? []
    : [
        {
          button_label: "Add Additional Patient Pay Schedule Step",
          button_handeler: () => {
            validateAddAdditionalPatPayScheduleStep();
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
        {
          button_label: "Note",
          button_handeler: () => {
            //navigateToPage(ADD_PRICE_SCHEDULE);
            navigateToPage(ROUTE_PATHS.ADDITIONAL_PATIENT_PAY_NOTE, [
              ...previousState,
              { ...currentState, currentIndex },
              {
                selectedAdditionalPatients: [selectedSchedules[currentIndex]],
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F14",
        },
      ];

  /* Gear Icon Menu option CTAs */
  const menuOptions = selectMode
    ? [
        {
          label: "Select",
          icon: <span className="material-icons">add</span>,
          command: () => {
            const paramData = selectParams.reduce((acc, key) => {
              if (rowData.hasOwnProperty(key["target"])) {
                acc[key["source"]] = rowData[key["target"]];
              }
              return acc;
            }, {});
            if (lookupType !== "external") {
              onSelect(paramData);
            } else {
              window.parent.postMessage(paramData);
            }
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            /* const message = {
              message: "navigate-to-presto",
              programCode: "RCAPT005",
              parameters: {
                apsAddtlPatPaySch: rowData["apsAddtlPatPaySch"],
                aptStepsNbr: rowData["aptStepsNbr"],
              },
            };
            console.log(message, "message");
            window.parent.postMessage(message, "*");
            */
            onNavigate({
              data: rowData,
              target: ROUTE_PATHS.ADDITIONAL_PATIENT_PAY_STEPS_DISPLAY,
              navType: "local",
              schedulesDataKey: "selectedSchedules",
              additionalData: {
                scheduleName: paramsData.schedule,
                scheduleDescription: paramsData.description,
              },
            });
          },
        },
      ]
    : [
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage(ADDITIONAL_PATIENT_PAY_STEPS_EDIT, [
              ...previousState,
              { ...currentState, currentIndex },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                scheduleName: paramsData.schedule,
                scheduleDescription: paramsData.description,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            console.log(
              "additional",
              rowData,
              rowData.apsAddtlPatPaySch,
              paramsData.schedule
            );
            navigateToPage(ADDITIONAL_PATIENT_PAY_STEPS_DISPLAY, [
              ...previousState,
              { ...currentState, currentIndex },
              {
                selectedSchedules: selectedRows.length
                  ? selectedRows
                  : [rowData],
                previousScreen: location.pathname,
                scheduleName: paramsData.schedule,
                scheduleDescription: paramsData.description,
              },
            ]);
          },
        },
      ];

  /* Data table column info. */
  const columnDef = [
    {
      header: "Step",
      field: "aptStepsNbr",
    },
    {
      header: "Step Basis",
      field: "aptBasis",
    },
    {
      header: "Step Max Value",
      field: "aptMaxValue",
    },
    {
      header: "Step Amount",
      field: "aptAddtlPatPayAmt",
    },
    {
      header: "Step Percent",
      field: "aptPercentOfCalcBasis",
    },
    {
      header: "Step Calc Basis",
      field: "aptCalcBasis",
    },
    {
      header: "Step MAC List",
      field: "macList",
      body: (rowData) => (
        <Button
          label={rowData.macList}
          link
          onClick={() => handleMacListLookupClick(rowData)}
        />
      ),
    },
    {
      header: "Step Cost Source",
      field: "aptCostSource",
    },
    {
      header: "Step Reject Code",
      field: "aptClaimReject",
    },
  ];

  /* Param Key which used as bridge between various operations on tabluar data */
  const parmKey = "aptStepsNbr";

  /* Handler that fetches the data */
  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/aptAddlPatPaySchedStps`,
        null,
        {
          // selectedSchedules[initialIndex].apsAddtlPatPaySch
          schedule: paramsData.schedule,
          page: page,
          size: rows,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  useEffect(() => {
    if (currentIndex !== initialIndex)
      setParamsData(getParamsData(selectedSchedules, currentIndex));
  }, [currentIndex, initialIndex]);

  useEffect(() => {
    fetchData(); // Initial fetch with page 0 and page size 10
  }, [paramsData, rows, currentPage]);

  const onPageChange = (event) => {
    console.log("page change", event.first, event);
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    console.log(selectedOption);
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteAdditionalPatientPaySteps = () => {
    if (selectedOption === "yes") {
      let stepNumbers = [];

      if (Array.isArray(selectedRows) && selectedRows.length > 0) {
        stepNumbers = selectedRows.map((row) => row.aptStepsNbr);
      } else if (rowData && Object.keys(rowData).length > 0) {
        stepNumbers[0] = rowData.aptStepsNbr;
      }

      if (stepNumbers.length > 0) {
        axios_helper_no_header(
          "DELETE",
          "api/aptAddlPatPaySchedStps",
          stepNumbers,
          {
            schedule: selectedSchedules[currentIndex].apsAddtlPatPaySch,
          }
        )
          .then((response) => {
            const updatedItems = data.filter(
              (item) => item[parmKey] !== rowData
            );
            setTotalRecords((prevTotal) => prevTotal - 1);
            setData(updatedItems);
            //fetchData();
            if (currentPage > 0) {
              setFirst(0);
              setCurrentPage(0);
            } else {
              fetchData();
            }
            toast.current.show({
              severity: "success",
              summary: "",
              detail: response.responseStatus.message,
              life: 3000,
            });
            closeConfirmationModal();
          })
          .catch((error) => {
            console.error("There was an error deleting the data!", error);
            const {
              responseStatus: { displayErrorFields = null, message } = {},
            } = error.data;
            toast.current.show({
              severity: "error",
              summary: "",
              detail: message,
              life: 3000,
            });
            closeConfirmationModal();
          });
      } else {
        closeConfirmationModal();
      }
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({
      schedule: selectedSchedules[initialIndex].apsAddtlPatPaySch,
    });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/aptAddlPatPaySchedStps/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  const validateAddAdditionalPatPayScheduleStep = () => {
    const params = {
      apsAddtlPatPaySch: selectedSchedules[currentIndex].apsAddtlPatPaySch,
    };
    axios_helper_no_header(
      "GET",
      "api/aptAddlPatPaySchedStps/validateStepAndBasisC",
      null,
      params
    )
      .then((response) => {
        navigateToPage(ADDITIONAL_PATIENT_PAY_STEPS_ADD, [
          ...previousState,
          { ...currentState, currentIndex },
          {
            previousScreen: location.pathname,
            selectedSchedules: [selectedSchedules[currentIndex]],
            scheduleName: paramsData.schedule,
            scheduleDescription: paramsData.description,
          },
        ]);
      })
      .catch((error) => {
        console.error("There was an error validating the data!", error);
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
        closeConfirmationModal();
      });
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    selectMode,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteAdditionalPatientPaySteps,
    setSelectedOption,
  };
};

export default useAdditionalPatientPaySteps;
